import { UI_Main } from 'ui/components/4-habitats/Main/Main';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_ArticleHeader } from 'ui/components/2-molecules/Article/ArticleHeader/ArticleHeader';
import { UI_ArticleByline } from 'ui/components/2-molecules/Article/ArticleByline/ArticleByline';
import { UI_ArticleAuthor } from 'ui/components/2-molecules/Article/ArticleAuthor/ArticleAuthor';
import { UI_ArticleDate } from 'ui/components/2-molecules/Article/ArticleDate/ArticleDate';
import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { Breadcrumb } from '2-feature/Navgation/Breadcrumb';

interface Props extends Content.Page {
	documentType: 'newsPage';
	properties: Content.BasePage &
		Content.PageHeaders & {
			newsDate: string;
			newsKicker: string;
			newsHeading: string;
			newsTeaser: string;
			newsAuthor: Content.Person;
			image: Content.Image;
			altText: string;
			imageCropping?: 'cover' | 'contain';
		};
}

export const NewsPage = ({ properties }: Props) => {
	const { newsTeaser, newsKicker, newsHeading, newsAuthor, newsDate, pageSections, image, altText, imageCropping } = properties ?? {};

	return (
		<UI_Main
			breadcrumb={<Breadcrumb />}
			useHeaderContainer
			header={
				<UI_ArticleHeader
					teaser={newsTeaser}
					heading={newsHeading}
					kicker={newsKicker}
					image={image}
					altText={altText}
					imageCropping={imageCropping}
				/>
			}
		>
			<UI_Container width="Narrow">
				<UI_ArticleDate date={newsDate} />
				{newsAuthor && <UI_ArticleByline {...newsAuthor?.properties} />}
			</UI_Container>
			{pageSections.map((pageSection, index) => {
				return <DynamicModule key={index} contentModule={pageSection} />;
			})}
			<UI_Container width="Narrow">{newsAuthor && <UI_ArticleAuthor {...newsAuthor?.properties} />}</UI_Container>
		</UI_Main>
	);
};
